import { useState } from 'react';
import axios from 'axios';
import Logo from "../Images/gtlogo.png"
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleLogin = async () => {
    try {
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/auth/login`, { email, password });
      const userData = { token: res.data.token, email };
      localStorage.setItem('user', JSON.stringify(userData));
      alert('✅ Logged in!');
      setEmail('');
      setPassword('');
      navigate('/admin/dashboard');
    } catch (err) {
      console.error(err);
      alert('❌ Invalid credentials');
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-pink-100">
      <div className="bg-white p-8 rounded-2xl shadow-lg w-full max-w-sm space-y-5">
        <img src={Logo} alt="" className='items-center justify-center' />
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full px-4 py-2 border border-red-200 rounded-md focus:outline-none focus:ring-2 focus:ring-pink-300 transition"
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full px-4 py-2 border border-red-200 rounded-md focus:outline-none focus:ring-2 focus:ring-pink-300 transition"
        />
        <button
          onClick={handleLogin}
          className="w-full bg-green-500 hover:bg-green-600 text-white font-semibold py-2 rounded-md transition"
        >
          Login
        </button>
      </div>
    </div>
  );
};

export default Login;
